'use client'

import { useSessionTracking } from '@/hooks/use-session-tracking'

/**
 * Session Tracker — renders nothing, just initializes heartbeat + beacon.
 * Mounted in root Providers alongside other analytics trackers.
 * Only activates when the user is authenticated.
 */
export function SessionTracker() {
  useSessionTracking()
  return null
}
